import formName from 'constants/formName'
import { actions, selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { ModalNameType } from 'data/App/types'
import { TwoFactorFormType } from 'data/types'
import { call, put, select } from 'redux-saga/effects'
import { verifyPassword } from 'services/api/auth'
import { Response } from 'utils/fetchApi'

import { goToStep } from './common'

const WRONG_PASSWORD_ERROR_CODE = 9
export default function* verifyPasswordStep(form: TwoFactorFormType) {
  const data: Response<void> = yield call(verifyPassword, form)
  const modalName: ModalNameType = yield select(selectors.app.getModalName)

  if (!data.ok) {
    yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))

    if (data.error.code === WRONG_PASSWORD_ERROR_CODE) {
      yield call(notifyError, data.error.cause, 'KO_GENERIC')
    }

    return
  }

  if (modalName === 'ENABLE_TWO_FACTOR') {
    yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))
    yield call(goToStep, 'method')
    return
  }

  if (modalName === 'BACKUP_CODES_TWO_FACTOR') {
    yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))
    yield call(goToStep, 'verifytwofactor')
  }
}
